<template lang="pug">
header.dawn-meta-nav(v-if="!featureFlags.legacyViewDisabled")
  div(:class="{ 'loading-mask' : $root.masked }")
  .container-fluid
    ul.meta-nav-menu

      li.meta-nav-item
        a(:href='helpsite()' target='_blank')
          i.fas.fa-question-circle
          span.title {{ $t(' Help Center') }}
      | &nbsp;
      | |
      | &nbsp;
      li.meta-nav-item
        a(@click='toggleNotifications' :href='notificationsCenter')
          i.fas.fa-bell.animated(:endpoint='api.$.common.notifications')
          | &nbsp;
          span.title {{ $t('Notifications') }}
          span.notif(v-show='newEvents.length')
        span.notification(v-show='newEvents.length') {{ newEvents.length }}
        .meta-nav-dropdown.notifications.arrow(v-if="showNotifications" v-on-clickaway='toggleNotifications')
          i.fa.fa-caret-up
          ul.meta-nav-dropdown-menu
            li.meta-nav-dropdown-item(v-for='notification in events' @click='toggleNotifications')
              a(:href='"#/i/Admin/UserNotification/GetNotificationCenter?notificationId=" + notification.AppNotificationId + "&fromPage=NotificationPopUp"')
                span.title {{ notification.Title }}
                span.desc {{ notification.CreatedDateFormatted }}
            li
              | &nbsp;&nbsp;&nbsp;
              ed-button(
                button-class='btn btn-actionbar-primary'
                @click='toggleNotifications'
                href='#/i/Admin/UserNotification/GetNotificationCenter'
              ) Notification Center
      | &nbsp;
      | |
      li.meta-nav-item.meta-nav-user.meta-nav-dropdown
        a(@click='toggleDropdown')
          i.fas.fa-user-circle
          //- ed-avatar.avatar-user(:size='16' :rounded='false' inline :username='currentCompany')
          | &nbsp;
          span(v-if='hasAccounts || hasEoAdminAccount') {{ currentCompany }}
            | &nbsp; - &nbsp;
          span.title {{ this.$user.email || 'Welcome !' }}
        .meta-nav-dropdown(v-if="showDropdown" v-on-clickaway='toggleDropdown')
          ul.meta-nav-dropdown-menu
            li.meta-nav-dropdown-title
              span.close-icon(@click='toggleDropdown')
            template(v-if='hasAccounts')
              //- li.meta-nav-dropdown-item.no-action()
                a(href="javascript:;" v-tooltip.left='currentCompany')
                  ed-avatar.avatar(:size='32' :rounded='false' inline :username='currentCompany')
                  | {{ currentCompany }}
            li.meta-nav-dropdown-item(@click='toggleDropdown')
              a(href="#/i/Admin/GeneralSettings/ConfigureUserProfile") {{ $t('My Profile') }}
            li.meta-nav-dropdown-item(@click='toggleDropdown')
              a(href="#/i/Admin/GeneralSettings/GeneralSettings") {{ $t('My Settings') }}
            template(v-if='hasEoAdminAccount')
              li.meta-nav-dropdown-item(@click='toggleDropdown')
                a(href="javascript:;" @click="switchToEoAdminAccount()") {{ $t('Back to EO Admin') }}
            template(v-if='hasAccounts')
              li.meta-nav-dropdown-item.no-action-(@click='toggleDropdown')
                a(href="javascript:;" @click="switchAccount()") {{ $t('Switch Accounts') }}
              //- li.meta-nav-dropdown-item(
              //-   v-for='(account, id) in accounts'
              //-   v-show='account != currentCompany'
              //-   @click="toggleDropdown"
              //- )
                a(href="#" @click='switchAccount(id)' v-tooltip.left='account')
                  ed-avatar.avatar(:size='32' :rounded='false' inline :username='account')
                  | {{ account }}
            li.meta-nav-dropdown-item(@click='toggleDropdown')
              a(href="#/login" @click='logout()') {{ $t('Logout') }}
</template>

<script>
import featureFlags from '@/core/feature-flags/feature-flags'
import { setUser, setUserSettings } from '@/components/Login/loginService'
import { navigateToV3Home } from '@/core/legacy-auth/gotoV3'
import '@/core/notifications'
import events from '@/core/events/events'
// import tour from '@/components/tour'

import { mixin as clickaway } from 'vue-clickaway'

export default {
  name: 'ed-meta-nav',

  mixins: [ clickaway ],

  data () {
    return {
      featureFlags,
      showDropdown: false,
      showNotifications: false,
      events: events.queue,
      newEvents: []
    }
  },

  computed: {
    notificationsCenter() {
      // return this.events && this.events.length ? 'javascript:;' : '#/i/Admin/UserNotification/GetNotificationCenter'
      return 'javascript:;'
    },
    accounts() {
      return this.$user.sessionSettings && this.$user.sessionSettings.UserCompanies || {}
    },
    hasAccounts() {
      return Object.keys(this.accounts).length > 1
    },
    currentCompany() {
      return this.$user.$.data.CompanyName
    },
    hasEoAdminAccount() {
      return this.$user.sessionSettings && this.$user.sessionSettings.HasEoAdminAccount
    }
  },

  methods: {
    switchAccount(account = {}) {
      const id = account.id
      if (!id) {
        this.$router.push({
          query: {
            ...this.$route.query,
            switchAccount: ''
          }
        })

        return
      }

      if (account.name === this.currentCompany) {
        if (account.type === 1) {
          navigateToV3Home.call(this)
        }

        if (this.$router.currentRoute.name === 'switchaccount') {
          window.history.go(-2)
        }

        return
      }

      this.api.get(this.api.$.initLegacy, { params: {'companyId': id} })

      this.api.get(this.api.$.settings.my.switch, {
        params: {
          companyId: id
        }
      }).then(settings => {
        let redirectUrl = settings.data &&
          settings.data.RedirectUrl
        if (redirectUrl) {
          global.location.href = redirectUrl
        } else {
          let user = settings.data &&
            settings.data.UserLogin
          if (user) {
            // user.sk = 'dummy'
            setUser.call(this, user)
            setUserSettings.call(this, settings, null, {
              returnUrl: ''
            }, !featureFlags.legacyViewDisabled)

            this.$routerHistory.push(this.$route.path)
            // window.location.reload()

            navigateToV3Home.call(this, user)
          }
        }
      })
    },

    switchToEoAdminAccount() {
      this.api.get(this.api.$.settings.my.switchToEoAdmin).then(r => {
        let redirectUrl = r.data
        if (redirectUrl) {
          redirectUrl = new URL(redirectUrl)
          redirectUrl.host = window.location.host
          redirectUrl.pathname = window.location.pathname

          global.location.href = redirectUrl
        }
      })
    },

    toggleDropdown() {
      this.showDropdown = !this.showDropdown
      this.$root.masked = this.showDropdown
    },

    toggleNotifications() {
      this.showNotifications = !this.showNotifications
      this.$root.masked = this.showNotifications

      if (this.showNotifications && this.newEvents.length) this.markAsRead()
    },

    markAsRead() {
      this.api.forms.post(this.api.$.common.readNotifications, {
        appNotifications: this.newEvents
      })
    },

    logout() {
      this.$user.logout()
    },

    helpsite() {
      return this.$user.$.data.IsE360 === true ? 'https://eved.my.site.com/EventCompany/s/' : (this.$user.$.data.MarketTypeID === 1 ? 'https://eved.my.site.com/Client/s/' : 'https://eved.my.site.com/Supplier/s/')
    }
    /* ,
    tour() {
      tour.reset()
      tour.show(this.$route)
    } */
  },

  created() {
    const vm = this

    // get notifications
    this.api.get(this.api.$.common.notifications).then(r => {
      vm.events = r.data.Data

      vm.newEvents = vm.events
                      .filter(notification => notification.IsViewed === false)
                      .map(notification => notification.AppNotificationId)
    })
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";
@import "~@/assets/sass/font-awesome/_animated.scss";

.loading-mask {
  background: #000;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 2;
  opacity: 0;
}

.notification{
  margin-right: 5px !important;
}

.notif{
  padding-right:15px;
}

.dawn-meta-nav {
  position: relative;
  z-index: 999999;
  display: block;
  width: 100%;
  padding: .3rem $side-padding;
  text-align: right;
  font-size: $font-size-small;
  line-height: $font-size-small;
  @include theme { background: v(primary-05) }
  @include theme(true) { background: lighten(v(background-light), 5%) }
}

ul.meta-nav-menu {
  display: inline-block;
  list-style: none;
  padding: 0;
  position: relative;
  text-align: left;
  margin-bottom: 0;
  @include theme { color: v(primary-03) }

  .avatar {
    margin: 0 5px 0 0;
  }
  .fa-user-circle {
    position: relative;
    top: 1px;
  }

  li.meta-nav-item {
    position: relative;
    display: inline-block;
    margin: 0rem .5rem;

    &.meta-nav-dropdown {
      position: static;
    }

    a {
      //@include theme { color: v(canvas) }
      //opacity: 0.3;
      @include theme { color: v(primary-03) }
      transition: color .5s ease-out;
      //transition: opacity .5s ease-out;
      &:hover {
        @include theme { color: v(canvas) }
        @include theme(true) { color: v(ink) }
        //opacity: 1;
        text-decoration: none;
        cursor: pointer;
      }
    }
  }

  li.meta-nav-user {
    // margin-left: 1rem;
    //text-transform: uppercase;
    .avatar-user {
      vertical-align: middle;
      >>> span {
        font-size: 8px !important;
      }
    }
  }

  div.meta-nav-dropdown {
    position: absolute;
    top: 1.8em;
    right: .3rem;
    @include theme { background: v(canvas) }
    box-shadow: $box-shadow;
    width: 40%;
    z-index: 9999;
    border-radius: 2px;
    padding-bottom: 6px;
    padding-top: 6px;

    &.arrow {
      .fa-caret-up {
        @include theme { color: v(canvas) }
        position: absolute;
        top: -.5rem;
        right: .5rem;
      }
    }

    &.notifications {
      left: auto;
      padding: 6px 0px 6px 0px;
      right: -.4rem;
      min-width: 200px;
      width: auto;

      li a {
        @include theme { color: v(canvas) }
      }

      ul.meta-nav-dropdown-menu {
        li.meta-nav-dropdown-item {
          a {
            line-height: 1;
          }
        }
      }
    }

    ul.meta-nav-dropdown-menu {
      list-style: none;
      padding: 0;

      li.meta-nav-dropdown-title {
        font-weight: $font-weight-bold;
        //margin-bottom: .3rem;
        @include theme { color: v(primary-05) }

        span.close-icon {
          @include theme { color: v(primary-05) }
          position: absolute;
          right: 1rem;
          top: .3rem;
          &:hover {
            cursor: pointer;
          }
        }
      }

      li.meta-nav-dropdown-item {
        border-radius: $border-radius;
        padding: .3rem 0rem .3rem;

        > a {
          display: block;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .title {
          display: block;
          font-weight: $font-weight-bold;
          @include theme { color: v(ink) }
        }
        .desc {
          font-size: $font-size-base-sm;
          opacity: .7;
          @include theme { color: v(ink) }
        }

        a {
          padding: 0 .5rem;
          @include theme { color: v(ink) }
          opacity: 1;
          font-size: $font-size-small;
          line-height: 2em;
          height: 100%;
        }

        &:hover {
          @include theme { background: v(background-light) }
          transition: all .5s ease-out;
        }

        &.no-action, &.no-action a {
          // pointer-events: none;
          cursor: default;
          @include theme { background: v(canvas) }
        }
      }
    }
  }
}

.fa-bell.loading {
  @include fa-ring;
}

</style>



// WEBPACK FOOTER //
// src/core/components/edMetaNav/index.vue